var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { "pb-3": "", "pt-1": "", "fill-height": "", row: "", wrap: "" } },
    [
      _c(
        "v-flex",
        { staticClass: "user--info__avatar", attrs: { "mt-2": "", xs2: "" } },
        [
          _c("v-avatar", { attrs: { size: "40", color: _vm.avatarColor } }, [
            _c("span", { staticClass: "headline white--text" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("acronym")(_vm.fullname)) +
                  "\n      "
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        {
          staticClass: "user--info__main",
          class: { "ml-1": _vm.twoLine },
          attrs: { "mt-2": "", xs10: "", "text-xs-left": "" }
        },
        [
          _c("div", [
            _c("b", [_vm._v(" " + _vm._s(_vm.fullname) + " ")]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("p", { staticClass: "mt-1 mb-0" }, [
              _vm._v(_vm._s(_vm.roleValue))
            ])
          ]),
          _vm._v(" "),
          _c(
            "ul",
            {
              staticClass: "pl-0 user--info__coordinates mt-2",
              staticStyle: { "list-style": "none" }
            },
            [
              _c(
                "li",
                { staticClass: "mb-1" },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: { small: "", color: _vm.iconColor }
                    },
                    [_vm._v("email")]
                  ),
                  _vm._v(" " + _vm._s(_vm.email))
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "mb-1" },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: { small: "", color: _vm.iconColor }
                    },
                    [_vm._v("call")]
                  ),
                  _vm._v(" " + _vm._s(_vm.landline || "-"))
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "mb-1" },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: { small: "", color: _vm.iconColor }
                    },
                    [_vm._v("stay_primary_portrait")]
                  ),
                  _vm._v(" " + _vm._s(_vm.cellphone || "-"))
                ],
                1
              ),
              _vm._v(" "),
              _vm.address && _vm.address.line1
                ? [
                    _c(
                      "li",
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "mr-2",
                            attrs: { small: "", color: _vm.iconColor }
                          },
                          [_vm._v("place")]
                        ),
                        _vm._v(" " + _vm._s(_vm.address.line1))
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.address.line2
                      ? _c("li", { staticClass: "ml-4 pl-1" }, [
                          _vm._v(_vm._s(_vm.address.line2))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("li", { staticClass: "ml-4 pl-1" }, [
                      _vm._v(_vm._s(_vm.address.zip_code) + " "),
                      _c("span", { staticClass: "ml-3" }, [
                        _vm._v(_vm._s(_vm.address.city))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "ml-4 pl-1" }, [
                      _vm._v(_vm._s(_vm.address.country))
                    ])
                  ]
                : _vm._e()
            ],
            2
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-687d2b4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-687d2b4a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/user-profile-enhanced-widget/template.html
// module id = null
// module chunks = 